var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as i0 from "@angular/core";
var SettingsState = /** @class */ (function () {
    function SettingsState() {
        /**
         * Initial settings before any changes.
         */
        this.initial = { server: {}, client: {} };
        /**
         * Server settings model.
         */
        this.server = {};
        /**
         * Client settings model.
         */
        this.client = {};
    }
    /**
     * Get settings that have been modified.
     */
    SettingsState.prototype.getModified = function () {
        return {
            server: this.diffSettingObjects('server'),
            client: this.diffSettingObjects('client'),
        };
    };
    /**
     * Diff specified setting object with initial one.
     */
    SettingsState.prototype.diffSettingObjects = function (name) {
        var changed = {};
        for (var key in this[name]) {
            if (this[name][key] !== this.initial[name][key]) {
                changed[key] = this[name][key];
            }
        }
        return changed;
    };
    /**
     * Set all settings on the store.
     */
    SettingsState.prototype.setAll = function (settings) {
        this.initial = settings;
        this.client = Object.assign({}, settings.client);
        this.server = Object.assign({}, settings.server);
    };
    SettingsState.prototype.reset = function () {
        this.server = __assign({}, this.initial.server);
        this.client = __assign({}, this.initial.client);
    };
    SettingsState.ngInjectableDef = i0.defineInjectable({ factory: function SettingsState_Factory() { return new SettingsState(); }, token: SettingsState, providedIn: "root" });
    return SettingsState;
}());
export { SettingsState };
